<template>
  <div v-if="!fetching" class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="add-publishings" @click="handleAddPublishingButtonClick">
          + Start New App
        </span>
        <span class="search">
          <label>
            <img :src="searchIconSVG" />
            <input
              type="search"
              class="search-input"
              placeholder="Search your MyApps"
              v-model="searchStr"
            />
          </label>
        </span>
        <spreadsheet
          v-if="v2"
          ref="spreadsheet"
          :columns="columns"
          :content="content"
          :file-name="`${profile.firstname}_Publishings`"
          sheet-name="Publishings"
        />
        <spreadsheet-upload
          v-if="v2"
          ref="spreadsheet-upload"
          :columns="columns"
          @process-items="handleProcessPublishings"
        />
      </div>
      <div class="publishings" role="tablist">
        <publishing-card
          v-for="(aPublishing, idx) in publishings"
          :publishing="aPublishing"
          :idx="idx"
          :key="`pub_${idx}`"
          @edit-publishing="handleEditPublishing"
          @delete-publishing="handleDeletePublishing"
          @feature-click="handleFeatureClick"
        />
      </div>
    </div>
    <add-edit-publishing-modal
      :ref="publishingModal"
      :modal-id="publishingModal"
      @add-publishing="handleAddPublishing"
      @update-publishing="handleUpdatePublishing"
    />
    <vimeo-modal
      v-if="activeVideo"
      :id="authorPublishingVideo"
      :videoId="activeVideo.videoId"
      :videoThumb="activeVideo.videoThumb ? activeVideo.videoThumb : null"
    />
    <!----TOOLS for Publishers App Development -->
    <tool-corner-editor
      :sidebar-id="cornerId"
      :publishing-id="selectedPublishingId"
      @refresh-publishings="handleRefreshPublishings"
    />
    <tool-development
      :sidebar-id="developmentId"
      :publishing-id="selectedPublishingId"
      @refresh-publishings="handleRefreshPublishings"
    />
    <tool-data
      :sidebar-id="dataId"
      :publishing-id="selectedPublishingId"
      @refresh-publishings="handleRefreshPublishings"
    />
    <!---PREMIUM FEATURES -->
    <tool-qr-generator
      :sidebar-id="qrId"
      :publishing-id="selectedPublishingId"
      @refresh-publishings="handleRefreshPublishings"
    />
    <tool-insights-viewer
      :sidebar-id="insightsId"
      :publishing-id="selectedPublishingId"
      @refresh-publishings="handleRefreshPublishings"
    />
    <!----- MODALS ---->
    <delete-publishing-modal
      :modal-id="modalIdDelete"
      :item-type="itemTypeDelete"
      :item-name="itemNameDelete"
      :item-id="itemDeleteItemId"
      @delete-item="handleDeletePublishingConfirmation"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import PublishingCard from "./publishingCard";
import AddEditPublishingModal from "./addEditPublishingModal";
import DeletePublishingModal from "@/components/modals/modalDelete";
import vimeoModal from "@/components/common/vimeoModal";
import VideoHandling from "@/mixins/VideoHandling";
import UploadImage from "@/mixins/UploadImage";

//Platform Tools
import ToolCornerEditor from "./sidebars/toolCornerEditor";
import ToolQrGenerator from "./sidebars/toolQRGenerator";
import ToolInsightsViewer from "./sidebars/toolInsightsViewer";
import ToolDevelopment from "../../platform/publishings/sidebars/toolDevelopment";
import ToolData from "../../platform/publishings/sidebars/toolData";

import Spreadsheet from "@/components/common/spreadsheet";
import SpreadsheetUpload from "@/components/common/spreadsheetUpload";
import moment from "moment";
export default {
  name: "ManageTabPublishing",
  mixins: [UploadImage, VideoHandling],
  components: {
    PublishingCard,
    AddEditPublishingModal,
    vimeoModal,
    Spreadsheet,
    ToolCornerEditor,
    ToolQrGenerator,
    ToolInsightsViewer,
    DeletePublishingModal,
    SpreadsheetUpload,
    ToolDevelopment,
    ToolData
  },
  props: {},
  data() {
    return {
      v2: false,
      searchIconSVG: require("@/assets/svg/search-icon.svg"),
      success: [],
      modalIdDelete: "delete-modal-id",
      itemTypeDelete: null,
      itemNameDelete: null,
      itemDeleteItemId: null,
      showingMore: false,
      selectedPublishing: {},
      selectedPublishingId: null,
      fetching: false,
      publishingModal: "publishing-modal",
      authorPublishingVideo: "author-publishing-video",
      refresh: 1,
      showCard: false,
      add: true,
      del: false,
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false,
      searchStr: "",
      clear: false,
      trackContent: {},
      seo: "",
      asset: "",
      popupText: "Copy to clipboard",
      uploadingImage: false,
      activeImage: "",
      imgDataUrl: "",
      imgURL: "",
      trackPassing: {},
      publishing: {
        title: "",
        description: {},
        subtitle: "",
        language: "",
        publisher: "",
        published_at: "",
        isbn: "",
        author: "", //Will be part of crew
        editor: "", //Will be part of crew
        illustrator: "", //Will be part of crew
        pages: null,
        reviews: null,
        price: null,
        tools: [], //------------
        series: [],
        publishingRights: "",
        keywords: [],
        adultContent: "",
        seo: [],
        spheres: [],
        guides: [],
        engines: [],
        connections: [],
        imgURL: "",
        weeks: 0,
        roles: null,
        categories: "",
        languages: null,
        age: 3,
        leaningStyle: "",
        Copyright: ""
      },
      rolesArray: [],
      languagesArray: [],
      activeVideo: null,
      processingVideo: false,
      activePublishingStatus: null,
      activePublishing: null,
      engines: [],
      addedEngines: [],
      oldEngines: [],
      showEngine: false,
      showUpload: false,
      uploadingScreen: false,
      currIndex: "",
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      cornerId: `corner`,
      qrId: `qr`,
      insightsId: `insights`,
      developmentId: `development`,
      dataId: `data`,
      fields: [
        { key: "id", sortable: true, label: "ID", isAvail: true, inSS: true },
        {
          key: "title",
          sortable: true,
          label: "Title",
          tdClass: "colWidth",
          isAvail: true,
          inSS: true
        },
        {
          key: "coverImage",
          label: "Cover",
          isAvail: true,
          inSS: false
        },
        { key: "description", label: "Description", isAvail: true, inSS: true },
        {
          key: "owner",
          label: "Owner",
          isAvail: true,
          inSS: true
        },
        {
          key: "editStatus",
          label: "Status",
          isAvail: true,
          inSS: false
        },
        {
          key: "status",
          label: "Status",
          isAvail: false,
          inSS: true
        },
        {
          key: "editInfo",
          label: "Actions",
          isAvail: true,
          inSS: false
        },
        {
          key: "feedback",
          label: "Feedback",
          isAvail: true,
          inSS: true
        },

        {
          key: "docURL",
          label: "DocURL",
          isAvail: false
        },
        { key: "isbn", label: "ISBN", isAvail: false },
        { key: "language", label: "Language", isAvail: false },
        { key: "pages", label: "Pages", isAvail: false },
        { key: "price", label: "Price", isAvail: false },
        { key: "category", label: "Category", isAvail: false },
        { key: "publisher", label: "Publisher", isAvail: false },
        { key: "status", label: "Status", isAvail: false },
        { key: "subtitle", label: "Subtitle", isAvail: false },
        { key: "tools", label: "TOOLS", isAvail: false },
        { key: "_created_at", label: "Created", isAvail: false },
        { key: "_submitted_at ", label: "Submitted", isAvail: false },
        { key: "_updated_at", label: "Updated", isAvail: false },
        { key: "copyright", label: "Copyright", isAvail: false },
        { key: "imgURL", label: "Cover", isAvail: false }
      ]
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      listPublishings: "user/listPublishings",
      getLocalPublishingWithId: "user/getLocalPublishingWithId"
    }),
    publishings() {
      return this.listPublishings.filter(publishing => {
        return publishing.title
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim());
        /* || publishing.subtitle
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim())*/
      });
    },
    columns() {
      return this.convertFieldToColumn(this.fields);
    },
    content() {
      return this.convertItemsToContent(this.publishings);
    }
  },
  methods: {
    async handleProcessPublishings(jsonPublishings) {
      // mark source:upload_<userId>_ts
      //Verify that header is valid
      let tStamp = new Date().valueOf();
      if (jsonPublishings && Array.isArray(jsonPublishings)) {
        for (const aPublishing of jsonPublishings) {
          if (aPublishing) {
            aPublishing.source = `upload_${this.user.uid}_${tStamp}`;
            await this.handleAddPublishing(aPublishing)
              .then(response => {
                this.success.push(aPublishing.title);
                console.log(response);
              })
              .catch(err => {
                console.log(`Error: ${err}`);
              });
          }
        }
      }
    },
    handleAddPublishingButtonClick() {
      //console.log("Click");
      this.$refs["publishing-modal"].showAddPublishing();
    },
    handleEditPublishing(publishing) {
      this.$refs["publishing-modal"].showEditPublishing(publishing);
    },
    handleDeletePublishing(publishing) {
      this.itemNameDelete = publishing.title;
      this.itemTypeDelete = "Publishing";
      this.itemDeleteItemId = publishing.id;
      this.$bvModal.show(this.modalIdDelete);
    },
    handleDeletePublishingConfirmation(publishingId) {
      this.deletePublishing(publishingId);
      //console.log(`Delete ${publishingId}`);
    },
    handleAddPublishing(publishingToAdd) {
      return new Promise((response, reject) => {
        let publishing = {
          id: `publishing_${this.generatePublishingId(20)}`,
          _created_at: new Date(),
          status: "draft",
          title: publishingToAdd.title
        };
        if (publishingToAdd.subtitle)
          publishing.subtitle = publishingToAdd.subtitle;
        if (publishingToAdd.description)
          publishing.description =
            typeof publishingToAdd.description === "string" ||
            publishingToAdd.description instanceof String
              ? JSON.parse(publishingToAdd.description)
              : publishingToAdd.description;

        if (publishingToAdd.languages)
          publishing.languages = publishingToAdd.languages;
        if (publishingToAdd.publisher)
          publishing.publisher = publishingToAdd.publisher;
        if (publishingToAdd.isbn) publishing.isbn = publishingToAdd.isbn;
        if (publishingToAdd.author) publishing.author = publishingToAdd.author;
        if (publishingToAdd.illustrator)
          publishing.illustrator = publishingToAdd.illustrator;
        if (publishingToAdd.editor) publishing.editor = publishingToAdd.editor;
        if (publishingToAdd.pages) publishing.pages = publishingToAdd.pages;
        if (publishingToAdd.reviews)
          publishing.reviews = publishingToAdd.reviews;
        if (publishingToAdd.price) publishing.price = publishingToAdd.price;
        if (publishingToAdd.tools) publishing.tools = publishingToAdd.tools;
        if (publishingToAdd.socials)
          publishing.socials = publishingToAdd.socials;
        //------
        if (publishingToAdd.series) publishing.series = publishingToAdd.series;
        if (publishingToAdd.category)
          publishing.category = publishingToAdd.category;
        if (publishingToAdd.copyright)
          publishing.copyright = publishingToAdd.copyright;

        //Authors, Illustrators, etc
        if (publishingToAdd.crew) {
          let namesToSave = [...publishingToAdd.crew];
          this.$store
            .dispatch("user/addNames", {
              names: namesToSave.length > 0 ? namesToSave : []
            })
            .then(async nameswUid => {
              await nameswUid.map((el, index) => {
                el._names_numbers_places_id = el.uid;
                delete el.uid;
                delete el._created_at;
                el.order = index;
                return el;
              });
              let roles = namesToSave.map(el => el.role);
              let filteredRoles = roles.filter((v, i, a) => a.indexOf(v) === i);
              let rolesToSave = filteredRoles.map(el => ({
                _created_at: new Date(),
                text: el
              }));
              return this.$store
                .dispatch("user/addRoles", {
                  roles: rolesToSave
                })
                .then(() => {
                  publishing.crew = nameswUid;

                  this.$store
                    .dispatch("user/addPublishing", publishing)
                    .then(res => {
                      if (res) {
                        this.$bvModal.hide(this.publishingModal);
                        this.resetForm();
                        this.getPublishings();
                        this.$store.dispatch("user/showNotification", {
                          title: `${publishing.title} added`,
                          description: `Your publishing has beeen added sucessfully`,
                          variant: "success"
                        });
                      }
                      response(res);
                    })
                    .catch(error => {
                      reject(error);
                    });
                });
            });
        } else {
          this.$store
            .dispatch("user/addPublishing", publishing)
            .then(res => {
              if (res) {
                this.$bvModal.hide(this.publishingModal);
                this.resetForm();
                this.getPublishings();
                this.$store.dispatch("user/showNotification", {
                  title: `${publishing.title} added successfully`,
                  description: "The Publishing has been added",
                  variant: "success"
                });
                response(res);
              }
            })
            .catch(error => {
              this.$store.dispatch("user/showNotification", {
                title: `${publishing.title} could not be added`,
                description: `${error}`,
                variant: "warning"
              });
              console.error(error);
              reject(error);
            });
        }
      });
      /*Theme
        series: this.publishing.series,
        publishingRights:this.publishing.publishingRights ? this.publishing.publishingRights : '',
        keywords: this.publishing.keywords,
        adultContent: this.publishing.adultContent ? this.publishing.adultContent : '',
        spheres: this.publishing.spheres,
        seo: this.publishing.seo,
        guides: this.publishing.guides,
        connections: this.publishing.connections,
        engines: this.publishing.engines,
        roles: this.publishing.roles,
        categories: this.publishing.categories,
        languages: this.publishing.languages,
        age: this.publishing.age,
        leaningStyle: this.publishing.leaningStyle,
        copyright: this.publishing.copyright,
        imgURL: "",
      };*/
    },
    handleUpdatePublishing(publishing) {
      console.log("...publishing.crew ", publishing.crew);
      // console.log("...this.crew => ",...this.crew);
      // return;
      if (publishing.crew && publishing.crew.length) {
        let namesToSave = publishing.crew;
        this.$store
          .dispatch("user/addNames", {
            names: namesToSave.length > 0 ? namesToSave : []
          })
          .then(async nameswUid => {
            //console.log("nameswUid =>",nameswUid);
            await nameswUid.map((el, index) => {
              el.uid ? (el._names_numbers_places_id = el.uid) : "";
              delete el.uid;
              delete el._created_at;
              el.order = index;
              return el;
            });
            let roles = namesToSave.map(el => el.role);
            let filteredRoles = roles.filter((v, i, a) => a.indexOf(v) === i);
            let rolesToSave = filteredRoles.map(el => ({
              _created_at: new Date(),
              text: el
            }));
            return this.$store
              .dispatch("user/addRoles", {
                roles: rolesToSave
              })
              .then(() => {
                publishing.crew = nameswUid;

                const payload = {
                  id: publishing.id,
                  updates: publishing
                };
                //console.log('payload',payload);
                this.$store
                  .dispatch("user/updatePublishing", payload)
                  .then(res => {
                    if (res) {
                      this.$bvModal.hide(this.publishingModal);
                      this.resetForm();
                      this.getPublishings();
                      this.$store.dispatch("user/showNotification", {
                        title: "Publishings Updated Successfully",
                        description: "Awesome",
                        variant: "success"
                      });
                    }
                  });
              });
          });
      } else {
        const payload = {
          id: publishing.id,
          updates: publishing
        };

        this.$store.dispatch("user/updatePublishing", payload).then(res => {
          if (res) {
            this.$bvModal.hide(this.publishingModal);
            this.resetForm();
            this.getPublishings();
            this.$store.dispatch("user/showNotification", {
              title: `${publishing.title} Updated Successfully`,
              description: "Your publishing has beeen updated",
              variant: "success"
            });
          }
        });
      }
    },
    handleFeatureClick(featureType, publishingId) {
      this.selectedPublishingId = publishingId;
      this.selectedPublishing = this.getLocalPublishingWithId(publishingId);
      //console.log(`Feature ${featureType} Publishing: ${this.selectedPublishingId}`);
      this.$root.$emit("bv::toggle::collapse", featureType);
    },
    handleRefreshPublishings() {
      //console.log("Get Publishings");
      this.getPublishings();
    },
    handleSelectPublishingForManagement() {
      this.$store
        .dispatch("user/setSelectedPublishingId", this.selectedPublishing.id)
        .then(data => {
          // console.log(`Publishing Id submitted`);
          // console.log(data);
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    handleViewClick(publishing, index) {
      // console.log("here => ", index);
      // this.showDashCard = true;
      this.trackPassing = publishing;
      this.showCard = true;
      this.$bvModal.show(`dashcard-${publishing.id}`);
    },
    convertFieldToColumn(fields) {
      const columns = JSON.parse(JSON.stringify(fields));
      columns.forEach(aColumn => {
        if (aColumn.hasOwnProperty("key")) {
          aColumn.value = aColumn.key;
          delete aColumn["key"];
        }
        if (aColumn.hasOwnProperty("sortable")) {
          delete aColumn["sortable"];
        }
        if (aColumn.hasOwnProperty("tdClass")) {
          delete aColumn["tdClass"];
        }
        if (aColumn.hasOwnProperty("formatter")) {
          delete aColumn["formatter"];
        }
        if (aColumn.hasOwnProperty("isAvail")) {
          delete aColumn["isAvail"];
        }
      });

      return columns;
    },
    convertItemsToContent() {
      const content = [];
      if (this.publishings && Array.isArray(this.publishings)) {
        let index = 1;
        this.publishings.forEach(anItem => {
          const publishing = anItem;
          const thisContent = {
            Index: index++,
            id: publishing.id,
            title: publishing.title,
            cover: publishing.imgURL,
            description: publishing.description,
            owner: "",
            status: "",
            copyright: publishing.copyright,
            isbn: publishing.isbn,
            language: publishing.language,
            pages: publishing.pages,
            _created_at: this.formatDate(publishing._created_at),
            _submitted_at: this.formatDate(publishing._submitted_at),
            _updated_at: this.formatDate(publishing._updated_at)
          };

          //TOOLS
          if (publishing.tools && Array.isArray(publishing.tools)) {
            let tools = "";
            publishing.tools.forEach(aTool => {
              const newTool = `(${aTool.toolId})${aTool.name}`;
              tools = tools.length > 0 ? `${tools},${newTool}` : newTool;
            });
            thisContent.tools = tools;
          }
          content.push(thisContent);
        });
      }
      return content;
    },
    formatDate(date) {
      //TODO- Move to mixin
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    getPublishings() {
      this.$store
        .dispatch("user/getListPublishings")
        .then(data => {
          //console.log("Publishings refreshed");
          //console.log(data);
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    getListedPublishing(event, publishing) {
      if (event.target.getAttribute("aria-expanded") == "true") {
        if (publishing.status !== "draft") {
          //this means that it has at east been submitted
          this.activePublishings = [];
          let existingPublishing = this.listPublishings.filter(
            lPublishing => lPublishing.id === publishing.id
          );
          if (existingPublishing.length == 0) {
            this.$store
              .dispatch("listings/getListPublishingById", publishing.id)
              .then(data => {
                this.activePublishings = data; //TODO Decide wehre to keep this publishing
                //console.log("thisPublishing => ", this.activePublishings);
              })
              .catch(error => {
                //console.log("Error getting document: ", error);
              });
          } else {
            this.activePublishings = existingPublishing[0];
          }
        }
      } else return;
    },
    submitPublishing(publishing) {
      let publishingType = "author";

      let owner = {
        firstname: this.profile.firstname ? this.profile.firstname : null,
        lastname: this.profile.lastname ? this.profile.lastname : null,
        imgURL: this.profile.imgURL ? this.profile.imgURL : null,
        profileName: this.profile._dashboards.guide.profileName
          ? this.profile._dashboards.guide.profileName
          : null, //will be global
        userId: this.profile.userId ? this.profile.userId : null
      };

      this.$store
        .dispatch("listings/submitPublishing", {
          publishing,
          owner,
          publishingType
        })
        .then(res => {
          if (res) {
            this.$store
              .dispatch("user/submitPublishing", publishing)
              .then(res => {
                this.getPublishings();
                this.$store.dispatch("user/showNotification", {
                  title: "Publishing Submitted Successfully",
                  description:
                    "Your publishing has now been submitted for Review",
                  variant: "success"
                });
              });
          }
        });
    },
    updatePublishing(publishing) {
      const payload = {
        id: this.publishings[this.activeIndex].id,
        updates: publishing
      };

      this.$store.dispatch("user/updatePublishing", payload).then(res => {
        if (res) {
          this.$bvModal.hide(this.publishingModal);
          this.resetForm();
          this.getPublishings();
          this.$store.dispatch("user/showNotification", {
            title: "Publishings Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    deletePublishing(id) {
      this.$store.dispatch("user/deletePublishing", id).then(res => {
        if (res) {
          this.$bvModal.hide(this.modalIdDelete);
          this.getPublishings();
          this.del = false;
          this.$store.dispatch("user/showNotification", {
            title: "Publishings Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    showDeletePublishing(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.publishingModal);
    },
    hideDeletePublishing() {
      this.$bvModal.hide(this.publishingModal);
    },
    setRolesArray() {
      this.$typeAheadRolesData.forEach(e => this.rolesArray.push(e.text));
    },
    hidePublishingModal(id) {
      this.$bvModal.hide(`dashcard-${id}`);
    },
    setLanguagesArray() {
      this.$typeAheadAboutsLanguage.forEach(e =>
        this.languagesArray.push(e.text)
      );
    },
    resetClear() {
      this.clear = false;
    },
    input(val) {
      this.publishing.description = val.content;
    },
    cancelAction() {
      this.resetForm();
      this.$bvModal.hide(this.publishingModal);
      this.refresh++;
    },
    getPublishingId(length) {
      //move to mixin
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    resetForm() {
      this.publishing = {
        title: "",
        subtitle: "",
        description: "",
        seo: [],
        spheres: [],
        tools: [],
        guides: [],
        connections: [],
        engines: [],
        imgURL: "",
        roles: null,
        weeks: 0,
        price: 0,
        categories: "",
        languages: [],
        age: 3,
        leaningStyle: "",
        copyright: ""
      };
      this.seo = "";
      this.activeIndex = null;
      this.activePublishingStatus = null;
      this.trackContent = {};
    },
    generatePublishingId(length) {
      //move to mixin
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      const date = new Date().valueOf();
      return `${this.user.uid}_${result}_${date}`;
    }
  },
  beforeMount() {},
  mounted() {
    this.fetching = false;
    this.getPublishings();
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (this.activeCollapse == collapseId) {
        this.activeCollapse = -1;
      }

      if (isJustShown) {
        this.activeCollapse = collapseId;
      }
    });
    this.setRolesArray();
    this.setLanguagesArray();
    this.$store.dispatch("user/getListNames");
    this.$store.dispatch("user/getListRoles");
  }
};
</script>

<style lang="scss" scoped>
.publishing-foot {
  display: flex;
  justify-content: space-between;
  .stats {
    display: flex;
    align-items: center;
    .ico {
      margin: 0 17px;
    }
  }
  .collapse-foot {
    display: flex;
    justify-content: flex-end;
    .btn-simple-primary {
      background-color: #fff;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      justify-content: center;
      padding: 8px 16px;
      border: none;
      display: flex;
      letter-spacing: 0.05em;
      align-items: center;
      color: var(--theme-color);
      margin-left: 16px;
      border-radius: 4px;
      transition: all 0.2s ease-in-out;
      svg {
        margin-right: 16px;
      }
      &:hover {
        background-color: #f3f6f9;
      }
      &.btn-start {
        background-color: #f3f6f9;
        &:hover {
          background-color: #dfdfdf;
          box-shadow: 0px 0px 4px 0px #eee;
        }
      }
    }
  }
}

.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 25%;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-publishings {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-publishing {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
  .editor {
    max-width: 100%;
    width: 100%;
    .editor__content {
      .ProseMirror {
        width: 100%;
        border: none;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8);
        border-radius: 20px;
        padding-left: 30px;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
        background: #fff;
        //border: 1px solid #ddd;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: 44px;
        -webkit-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
      }
    }
  }
}
.del-publishing {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.publishings {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
      .ico {
        margin: 0 17px;
        cursor: pointer;
      }
      .doc-ico {
        margin-left: 0;
      }
      .doc-link {
        color: var(--theme-color);
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
    .status-btn {
      display: inline-block;
      margin-right: 15px;
      width: 105px;
      height: 21px;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      background: var(--theme-color);
      text-align: center;
      border: none;
      border-radius: 3px;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
    img {
      cursor: pointer;
      position: relative;
      // top: 50%;
      right: 4px;
      // -webkit-transform: translateY(-50%);
      // transform: translateY(-50%);
      height: 100px;
      width: 100px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      background: rgba(85, 126, 251, 0.1);
      border-radius: 8px;
    }
    .publishing-description {
      left: 5px;
    }
  }
}
.places-lived {
  margin-top: 26px;
  .place__places-lived {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    margin: 6px 15px;
  }
  .del__ico {
    cursor: pointer;
  }
}
.submit-btn {
  border-radius: 28px;
  width: 120px;
}
.roles {
  margin-top: 25px;
}
.tools {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.crew {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-crew {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.video-sec {
  margin-left: 15px;
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
.description-title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  max-width: 354px;
  width: 100%;
  margin: 18px 0;
  cursor: pointer;
}
.half-fields {
  margin-left: 3px;
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
}
</style>
